import gql from 'graphql-tag';

export const getDashboardData = gql`
  query MyQuery {
    mocked {
      coaches {
        givenName
        username
      }
      customerMessages {
        channel
        comment
        contactID
        id
        workCategory
      }
      sharedProfiles {
        givenName
        username
      }
      updatedAt
      user {
        givenName
        username
      }
      weeklyData {
        hmdNo
        hmdOffers
        hmdResponses
        hmdYes
        prr
        prrGoal
        rap
        rapGoal
        repeat
        week
      }
    }
  }
`;

export const getCoachingNotes = gql`
  query CoachingNotes($week: Int!, $year: Int!, $userID: String) {
    coachingNotes(week: $week, year: $year, userID: $userID) {
      author {
        fullName
        username
        userID
      }
      content
      createdAt
      updatedAt
    }
  }
`;

export const getWeekData = gql`
  query GetWeekData($week: Int!, $year: Int!, $userID: String!) {
    getWeekData(week: $week, year: $year, userID: $userID) {
      hmdOffers
      hmdResponses
      hmdYes
      hmdNo
      repeat
      updatedAt
    }
  }
`;

export const getContactRecommendation = gql`
  query GetContactRecommendation(
    $userName: String!
    $userID: String!
    $startYear: Int!
    $startWeek: Int!
    $endYear: Int!
    $endWeek: Int!
  ) {
    getContactRecommendation(
      userName: $userName
      userID: $userID
      startYear: $startYear
      startWeek: $startWeek
      endYear: $endYear
      endWeek: $endWeek
    ) {
      contactID
      marketplaceID
      marketplaceDomainName
      contactDate
      sic
      skill
      category
      displayOrder
      calWeek
      calYear
      status
      contactJointID
      contactJointIndex
      amznHierarchy
      contactInfo {
        cscContactID
        goodRecommendation
        uncoachableReason
        uncoachableReasonText
        followedSecurityPolicies
        vertical
        content
        relatedMetric
      }
      deliverInfo {
        deliverStatus
        deliverDate
        noteID
      }
    }
  }
`;

export const getCustomerCommentsSecure = gql`
  query GetCustomerCommentsSecure(
    $week: Int!
    $year: Int!
    $userID: String
    $enableProfanityFilter: Boolean
  ) {
    getCustomerCommentsSecure(
      week: $week
      year: $year
      userID: $userID
      enableProfanityFilter: $enableProfanityFilter
    ) {
      content
      marketplaceID
      contactID
      marketplaceDomainName
      responseDateTime
    }
  }
`;

export const getInspireOptions = gql`
  query GetInspireOptions($userID: String) {
    getInspireOptions(userID: $userID) {
      isAdmin
      isTm
      isOm
      isExclusivelyOm
      enableCesComments
      enableCoachingNotes
      userID
      cscEntityPrefix
      requesterUserID
      requesterUsername
      requesterOwner
      manageCoachingNotes
    }
  }
`;

export const getProfileData = gql`
  query GetProfileData($userID: String!) {
    getProfileData(userID: $userID) {
      managers {
        userName
        userID
        displayName
        alias
        owner
        firstName
        lastName
        removable
        relationToUser
        homeRegion
      }
      sharedProfileCoaches {
        userName
        userID
        displayName
        alias
        owner
        firstName
        lastName
        removable
        relationToUser
        homeRegion
      }
      directReports {
        userName
        userID
        displayName
        alias
        owner
        firstName
        lastName
        removable
        relationToUser
        homeRegion
      }
      sharedProfileCoachees {
        userName
        userID
        displayName
        alias
        owner
        firstName
        lastName
        removable
        relationToUser
        homeRegion
      }
      user {
        userName
        userID
        displayName
        alias
        owner
        firstName
        lastName
        homeRegion
      }
      proxyCoaches {
        tmEntity {
          userName
          userID
          displayName
          alias
          owner
          firstName
          lastName
          removable
          relationToUser
          homeRegion
        }
        sharedReports {
          userName
          userID
          displayName
          alias
          owner
          firstName
          lastName
          homeRegion
        }
      }
      proxyCoachees {
        tmEntity {
          userName
          userID
          displayName
          alias
          owner
          firstName
          lastName
          removable
          relationToUser
          homeRegion
        }
        sharedReports {
          userName
          userID
          displayName
          alias
          owner
          firstName
          lastName
          homeRegion
        }
      }
    }
  }
`;

export const getTeamProfileData = gql`
  query GetTeamProfileData($userID: String!) {
    getTeamProfileData(userID: $userID) {
      reportingTeam {
        relatedUser {
          userName
          userID
          displayName
          alias
          owner
          firstName
          lastName
          removable
          relationToUser
          homeRegion
        }
        isManager
        subReports
      }
      user {
        userName
        userID
        displayName
        alias
        owner
        firstName
        lastName
        homeRegion
      }
    }
  }
`;

export const getFilterOptions = gql`
  query GetFilterOptions(
    $isTM: Boolean!
    $syncMetrics: Boolean
    $team: [String!]!
    $teamMemberIsTM: [Boolean!]!
    $timeOption: TimeOption!
    $timestamp: String!
    $userID: String!
    $isHistorical: Boolean
  ) {
    getFilterOptions(
      isTM: $isTM
      syncMetrics: $syncMetrics
      team: $team
      teamMemberIsTM: $teamMemberIsTM
      timeOption: $timeOption
      timestamp: $timestamp
      userID: $userID
      isHistorical: $isHistorical
    ) {
      channels
      marketplaces
      segments
      skills
      verticals
    }
  }
`;

export const getLighthouseMetrics = gql`
  query GetLighthouseMetrics(
    $channel: String!
    $directReports: [String!]!
    $isTM: Boolean!
    $marketplace: String
    $metrics: [LighthouseMetricOption!]!
    $segment: String!
    $skill: String!
    $syncMetrics: Boolean
    $timeOption: TimeOption!
    $timestamp: String!
    $userID: String!
    $vertical: String!
    $isHistorical: Boolean
  ) {
    getLighthouseMetrics(
      channel: $channel
      directReports: $directReports
      isTM: $isTM
      marketplace: $marketplace
      metrics: $metrics
      segment: $segment
      skill: $skill
      syncMetrics: $syncMetrics
      timeOption: $timeOption
      timestamp: $timestamp
      userID: $userID
      vertical: $vertical
      isHistorical: $isHistorical
    ) {
      userID
      metricTypes
      latestMetricPublishDate
      RAP {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHmdResponses {
            datapoint
            networkAverage
          }
          hmdYesAdjustedCount {
            datapoint
            networkAverage
          }
          prr {
            datapoint
            networkAverage
          }
          rapRepeatCount {
            datapoint
            networkAverage
          }
          hmdOfferRate {
            datapoint
            networkAverage
          }
          hmdResponseRate {
            datapoint
            networkAverage
          }
          hmdYesResponses {
            datapoint
            networkAverage
          }
          hmdNoResponses {
            datapoint
            networkAverage
          }
          fcr {
            datapoint
            networkAverage
          }
          nonOrderTaggingRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandability {
            datapoint
            networkAverage
          }
          attentive {
            datapoint
            networkAverage
          }
          friendliness {
            datapoint
            networkAverage
          }
          knowledgeable {
            datapoint
            networkAverage
          }
          empathy {
            datapoint
            networkAverage
          }
          courtesy {
            datapoint
            networkAverage
          }
          helpfulness {
            datapoint
            networkAverage
          }
          efficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX_NEG {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          negativeUnderstandability {
            datapoint
            networkAverage
          }
          negativeKnowledgeable {
            datapoint
            networkAverage
          }
          negativeEmpathy {
            datapoint
            networkAverage
          }
          negativeCourtesy {
            datapoint
            networkAverage
          }
          negativeHelpfulness {
            datapoint
            networkAverage
          }
          negativeEfficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CCX_NEG_ONEBOX {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          negativeOneboxUnderstandability {
            datapoint
            networkAverage
          }
          negativeOneboxKnowledgeable {
            datapoint
            networkAverage
          }
          negativeOneboxEmpathy {
            datapoint
            networkAverage
          }
          negativeOneboxCourtesy {
            datapoint
            networkAverage
          }
          negativeOneboxHelpfulness {
            datapoint
            networkAverage
          }
          negativeOneboxEfficiency {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      TR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          transferredContacts {
            datapoint
            networkAverage
          }
          muParkedRate {
            datapoint
            networkAverage
          }
          handledContacts {
            datapoint
            networkAverage
          }
          boomerangContactCount {
            datapoint
            networkAverage
          }
          consults {
            datapoint
            networkAverage
          }
          resolvedContacts {
            datapoint
            networkAverage
          }
          escalatedContacts {
            datapoint
            networkAverage
          }
          resolveRate {
            datapoint
            networkAverage
          }
          lockToResolve {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      ACHT {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          acwTime {
            datapoint
            networkAverage
          }
          holdTime {
            datapoint
            networkAverage
          }
          ttcForMessageUs {
            datapoint
            networkAverage
          }
          acwTimeInbound {
            datapoint
            networkAverage
          }
          acwTimeOutbound {
            datapoint
            networkAverage
          }
          highSilenceRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DART {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          dartUsedCount {
            datapoint
            networkAverage
          }
          totalHandledContact {
            datapoint
            networkAverage
          }
          escalatedContacts {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DCR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          giftCardsIssuedCount {
            datapoint
            networkAverage
          }
          oowExceptions {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      DSR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          dsrDenominator {
            datapoint
            networkAverage
          }
          dsrYes {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      SDR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          sdrDenominator {
            datapoint
            networkAverage
          }
          sdrYes {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CONSULT_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          consults {
            datapoint
            networkAverage
          }
          phoneHandledContacts {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      POLICY_ADHERENCE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          concessionGivenRate {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRRNC {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandabilityNoConcession {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRRCI {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          understandabilityConcessionIssued {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          ccxOverallService {
            datapoint
            networkAverage
          }
          attentive {
            datapoint
            networkAverage
          }
          friendliness {
            datapoint
            networkAverage
          }
          knowledgeable {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY_CONCESSION_ISSUED {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      UNDERSTANDABILITY_NO_CONCESSION {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      CONCESSION_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          promoteGCIssuedCount {
            datapoint
            networkAverage
          }
          oopExceptions {
            datapoint
            networkAverage
          }
          concessionIssuedPerContact {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      PRR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          hmdYesResponses {
            datapoint
            networkAverage
          }
          hmdNoResponses {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      HMD_OFFER_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHandledContact {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      HMD_RESPONSE_RATE {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        submetrics {
          totalHmdResponses {
            datapoint
            networkAverage
          }
          offerCount {
            datapoint
            networkAverage
          }
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      QCS {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
      FCR {
        topLevelMetrics {
          baseMetric {
            datapoint
            networkAverage
          }
          change
          previousDate
        }
        trend {
          timestamp
          datapoint
          networkAverage
        }
      }
    }
  }
`;
export const getDefaultVertical = gql`
  query GetDefaultVertical($userID: String!) {
    getDefaultVertical(userID: $userID)
  }
`;

export const getHMDDetails = gql`
  query GetHmdDetails(
    $userID: String!
    $isTM: Boolean!
    $directReports: [String!]
    $vertical: String!
    $skill: String!
    $channel: String!
    $segment: String!
    $marketplace: String
    $timeOption: TimeOption!
    $timestamp: String!
    $syncMetrics: Boolean
  ) {
    getHMDDetails(
      userID: $userID
      isTM: $isTM
      directReports: $directReports
      vertical: $vertical
      skill: $skill
      channel: $channel
      segment: $segment
      marketplace: $marketplace
      timeOption: $timeOption
      timestamp: $timestamp
      syncMetrics: $syncMetrics
    ) {
      yesResponses {
        userID
        contactID
        marketplaceName
        issueCode
        communicationDate
        responseDate
        channelCode
        rapRepeatContactId
        encryptedRapRepeatContactId
        workCategory
        verticalName
      }
      noResponses {
        userID
        contactID
        marketplaceName
        issueCode
        communicationDate
        responseDate
        channelCode
        rapRepeatContactId
        encryptedRapRepeatContactId
        workCategory
        verticalName
      }
      repeatResponses {
        userID
        contactID
        marketplaceName
        issueCode
        communicationDate
        responseDate
        channelCode
        rapRepeatContactId
        encryptedRapRepeatContactId
        workCategory
        verticalName
      }
      lastAuditDate
    }
  }
`;

export const getRealtimeHmdDetails = gql`
  query GetRealtimeHmdDetails(
    $userID: String!
    $isTM: Boolean!
    $directReports: [String!]
    $startDate: String!
    $endDate: String!
  ) {
    getRealtimeHmdDetails(
      userID: $userID
      isTM: $isTM
      directReports: $directReports
      startDate: $startDate
      endDate: $endDate
    ) {
      yesResponses {
        userID
        contactID
        marketplaceName
        issueCode
        communicationDate
        responseDate
        channelCode
        rapRepeatContactId
        encryptedRapRepeatContactId
        workCategory
        verticalName
      }
      noResponses {
        userID
        contactID
        marketplaceName
        issueCode
        communicationDate
        responseDate
        channelCode
        rapRepeatContactId
        encryptedRapRepeatContactId
        workCategory
        verticalName
      }
      repeatResponses {
        userID
        contactID
        marketplaceName
        issueCode
        communicationDate
        responseDate
        channelCode
        rapRepeatContactId
        encryptedRapRepeatContactId
        workCategory
        verticalName
      }
      lastAuditDate
    }
  }
`;

export const getFeedbackMessages = gql`
  query GetFeedbackMessages(
    $userID: String!
    $isTM: Boolean!
    $directReports: [String!]!
    $vertical: String!
    $channel: String!
    $skill: String!
    $segment: String!
    $timeOption: TimeOption!
    $timestamp: String!
    $metrics: [LighthouseMetricOption!]!
  ) {
    getFeedbackMessages(
      userID: $userID
      isTM: $isTM
      directReports: $directReports
      vertical: $vertical
      channel: $channel
      skill: $skill
      segment: $segment
      timeOption: $timeOption
      timestamp: $timestamp
      metrics: $metrics
    ) {
      userID
      performanceMessages {
        content
        metric
      }
    }
  }
`;

export const getOrgVertical = gql`
  query GetOrgVertical($userIds: [String!]!, $userID: String!) {
    getHPSUserProfiles(userIds: $userIds, userID: $userID) {
      profiles {
        USER_VERTICAL
      }
    }
  }
`;
